module.exports = __webpack_public_path__ + "assets/img/icon-traffic-light-gray.60e484a2.png";